import { gql } from '@apollo/client';

// Query for Getting Daily Record
export const GET_DAILY_RECORD = gql`
  query GetDailyRecord($params: getDailyRecordInput!) {
    getDailyRecord(params: $params) {
      UserID
      Date
      Leave
      StartTime
      EndTime
      Note
    }
  }
`;

// Query for Getting Records by Month
export const GET_DAILY_RECORD_BY_MONTH = gql`
  query GetDailyRecordsByMonth($params: getDailyRecordInput!) {
    getDailyRecordsByMonth(params: $params) {
      UserID
      Date
      Leave
      StartTime
      EndTime
      Note
    }
  }
`;

// Query for Creating Report
export const CREATE_REPORT = gql`
  mutation CreateReport($params: DailyRecordsInput!) {
    createReport(params: $params) {
      PresignedURL
    }
  }
`;

// User Management GraphQL Queries and Mutations
export const GET_USERS = gql`
  query GetAllUsers {
    getAllUsers {
      sequenceId
      lastName
      firstName
      sub
      email
      isPermanentEmployee
      externalCompany
      bulkDownloadTarget
      monitoringTarget
    }
  }
`;

export const GET_USER = gql`
  query GetUserById($id: ID!) {
    getUserById(id: $id) {
      sequenceId
      lastName
      firstName
      sub
      email
      isPermanentEmployee
      externalCompany
      bulkDownloadTarget
      monitoringTarget
    }
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      sequenceId
      lastName
      firstName
      sub
      email
      isPermanentEmployee
      externalCompany
      bulkDownloadTarget
      monitoringTarget
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      sequenceId
      lastName
      firstName
      sub
      email
      isPermanentEmployee
      externalCompany
      bulkDownloadTarget
      monitoringTarget
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`;
